export class qrPojo {

    txnid: number;
    txndate: Date;
    txnamount: number;
    bankrefno: string;

}
